<template>
   
   <vs-popup title="Mobil Siparişler" fullscreen :active.sync="orderListIsActiveLocal">
    <printer v-if="printeractive" ref="printer" :orderEntries="orderDetail.cartEntries" :totalPrice="orderDetail.totalPrice"
                 :totalDiscountPrice="orderDetail.totalCampaignDiscountAmount" :currentDateTime="currentDate"
                 :activePersonal="''  "/>
    <vs-row>
      <vs-col vs-w="3"><vs-button type="gradient" color="success" icon-pack="feather" icon="icon-refresh-cw" @click="getOrder()">Manuel Yenile</vs-button></vs-col>
      <vs-col vs-w="6"></vs-col>
      <vs-col vs-w="3"><vs-button type="gradient" color="success"  @click="readQr()">QR ile Teslim Et</vs-button></vs-col>
    
  
    
  </vs-row>
    <div class="kanban-board">
      <div class="kanban-column">
        <h1>Bekliyor</h1>
        <vs-card    v-for="order in orders" :key="order.id" v-if="order.orderStatus === 0">
     
      <div @click="showPopupDetail(order)" slot="header">
        <vs-row vs-align="flex-start">
            <vs-col vs-justify="center" vs-align="center" vs-w="5">
               Id
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-w="4">
              Teslimat
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-w="3">
              Kalan Süre
            </vs-col>
          </vs-row>
          <vs-row vs-align="flex-start">
            <vs-col vs-w="5">
              <h3>  {{ order.id }}</h3>
            </vs-col>
            <vs-col vs-w="4">
              <h3>{{order.deliveryDateString}}</h3>
            </vs-col>
            <vs-col vs-w="3">
              <h3> <div :class="{ 'warning': order.tableId <= 120 }">{{remainingTime(order.tableId)}}</div></h3>
            </vs-col>
            <!-- <vs-col vs-w="2" vs-type="flex"  vs-xs="12">
              <vs-button style="width: 100%;" size="large" full-width title="Detayları Göster" type="gradient" color="primary" icon-pack="pickicon" icon="icon-checklist" @click="showPopupDetail(order)"></vs-button>

          </vs-col>  -->
          </vs-row>
      </div>
      <div >
        <vs-row vs-align="flex-end">
          
           
            <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
              <vs-button size="large" full-width title="Siparişi iptal et" type="gradient" color="danger" icon-pack="feather" icon="icon-trash" @click="showPopup(order.id, -1)"><div full-width></div></vs-button>
            </vs-col>
            <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
              <vs-button size="large" full-width title="Siparişi görüntüle" type="gradient" color="primary" icon-pack="feather" icon="icon-eye" @click="showPopupDetail(order)" ><div full-width></div></vs-button>
            </vs-col>
            <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
              <vs-button size="large" full-width title="Siparişi hazırlanıyora çek" type="gradient" color="success" icon-pack="feather" icon="icon-chevrons-right" @click="showPopup(order.id, 1)"><div full-width></div></vs-button>
            </vs-col>
          </vs-row>
      </div>
    </vs-card>
      </div>
      <div class="kanban-column">
        <h1>Hazırlanıyor</h1>
        <vs-card v-for="order in orders" :key="order.id" v-if="order.orderStatus === 1">
     
      <div @click="showPopupDetail(order)" slot="header">
        <vs-row vs-align="flex-start">
            <vs-col vs-justify="center" vs-align="center" vs-w="5">
               Id
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-w="4">
              Teslimat
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-w="3">
              Kalan Süre
            </vs-col>
          </vs-row>
          <vs-row vs-align="flex-start">
            <vs-col vs-w="5">
              <h3> {{ order.id }}</h3>
            </vs-col>
            <vs-col vs-w="4">
              <h3>{{order.deliveryDateString}}</h3>
            </vs-col>
            <vs-col vs-w="3">
              <h3><div :class="{ 'warning': order.tableId <= 120 }">{{remainingTime(order.tableId)}}</div></h3>
            </vs-col>
          </vs-row>
      </div>
      <div >
        <vs-row vs-align="flex-end">
          <!-- <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
            <vs-button size="large" full-width title="Detayları Göster" type="gradient" color="primary" icon-pack="pickicon" icon="icon-checklist" @click="showPopupDetail(order)"><div full-width></div> </vs-button>
          </vs-col> -->
           
            <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
              <vs-button size="large" full-width title="Siparişi beklemeye geri çek" type="gradient" color="danger" icon-pack="feather" icon="icon-chevrons-left" @click="showPopup(order.id, 0)"><div full-width></div></vs-button>
            </vs-col>
            <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
              <vs-button size="large" full-width title="Siparişi görüntüle" type="gradient" color="primary" icon-pack="feather" icon="icon-eye" @click="showPopupDetail(order)" ><div full-width></div></vs-button>
            </vs-col>
            <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
              <vs-button size="large" full-width title="Siparişi tamamlandıya çek" type="gradient" color="success" icon-pack="feather" icon="icon-chevrons-right" @click="showPopup(order.id, 2)"><div full-width></div></vs-button>
            </vs-col>
          </vs-row>
      </div>
    </vs-card>
      </div>
     
      <div class="kanban-column">
        <h1>Tamamlandı</h1>
        <vs-card v-for="order in orders" :key="order.id" v-if="order.orderStatus === 2">
     
      <div @click="showPopupDetail(order)" slot="header">
        <vs-row vs-align="flex-start">
            <vs-col vs-justify="center" vs-align="center" vs-w="5">
               Id
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-w="4">
              Teslimat
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-w="3">
              Kalan Süre
            </vs-col>
          </vs-row>
          <vs-row vs-align="flex-start">
            <vs-col vs-w="5">
              <h3> {{ order.id }}</h3>
            </vs-col>
            <vs-col vs-w="4">
              <h3>{{order.deliveryDateString}}</h3>
            </vs-col>
            <vs-col vs-w="3">
              <h3><div :class="{ 'warning': order.tableId <= 120 }">{{remainingTime(order.tableId)}}</div></h3>
            </vs-col>
          </vs-row>
      </div>
      <div >
        <vs-row vs-align="flex-end">
          <!-- <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
            <vs-button size="large" full-width title="Detayları Göster" type="gradient" color="primary" icon-pack="pickicon" icon="icon-checklist" @click="showPopupDetail(order)"><div full-width></div> </vs-button>
          </vs-col> -->
           
            <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
              <vs-button size="large" full-width title="Siparişi hazırlanıyora geri çek" type="gradient" color="danger" icon-pack="feather" icon="icon-chevrons-left" @click="showPopup(order.id, 1)"><div full-width></div></vs-button>
            </vs-col>
            <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
              <vs-button size="large" full-width title="Siparişi görüntüle" type="gradient" color="primary" icon-pack="feather" icon="icon-eye" @click="showPopupDetail(order)" ><div full-width></div></vs-button>
            </vs-col>
            <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
              <vs-button size="large" full-width title="Siparişi Teslim Et" type="gradient" color="success" icon-pack="feather" icon="icon-chevrons-right" @click="showPopup(order.id, 3)"><div full-width></div></vs-button>
            </vs-col>
          </vs-row>
      </div>
    </vs-card>
      </div>
      <div fullscreen style="z-index: 9999999;" class="popup-overlay" v-if="showPopupFlag">
        <div fullscreen class="popup">
          <h3>İşlemi yapmak istediğinize eminmisiniz ?</h3>
          <p>Sipariş ID: {{ selectedOrder.id }}</p>
          <button class="btn btn-primary" @click="moveOrder(selectedOrder.id, selectedStatus)">Tamam</button>
          <button class="btn btn-secondary" @click="closePopup">İptal</button>
        </div>
      </div>
      <div style="z-index: 999;position: fixed; top: 0; left: 0; right: 0; bottom: 0;"  class="popup-overlay" v-if="showPopupDetailFlag">
        <div style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 100%; overflow-y: auto;"  class="popup">
          <h3>{{ orderDetail.id }} No lu Sipariş Detayı</h3>
          <p>Açıklama: {{ orderDetail.description }}</p>
  <table class="ana">
      <tr>
        <td>
          <table>
            <thead>
              <td>Ürün</td>
              <td>Miktar</td>
              <td>Reçete</td>
              <td>Ekstralar</td>
            </thead>
            <tbody>
              <tr v-for="entry in orderDetail.cartEntries" :key="entry.id">
                <td>{{ entry.productName }}</td>
                <td>x{{ entry.quantity }}</td>
                <td>{{ entry.description }}</td>
                <td><table>
                  <tr v-for="extra in groupExtras(entry.extras)" :key="index" v-if="extra.quantity > 0">
                    <td >
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+ {{ extra.name }}
                    </td>
                    <td>
                      x{{ extra.quantity }}
                    </td>
                  </tr>
                </table> </td>
              </tr>
            </tbody>
          </table>
          
        </td>
      </tr>
    </table>
        <div class="row">
          <div class="col-8"><button class="btn btn-warning" @click="closePopup">Kapat</button>
            <button class="btn btn-warning" @click="printing">Yazdır</button>
          </div>
          <div class="col-1"><vs-button  type="gradient" color="danger" icon-pack="feather" icon="icon-chevrons-left" @click="showPopup(orderDetail.id, orderDetail.orderStatus - 1)"><div full-width></div></vs-button></div>
          <div class="col-1">
            <vs-button type="gradient" color="success" icon-pack="feather" icon="icon-chevrons-right"  @click="showPopup(orderDetail.id, orderDetail.orderStatus + 1)"><div full-width></div></vs-button></div>
        </div>
          
        </div>
      </div>
      <div  class="popup-overlay" v-if="showQrReader">
        <div class="popup">
          <h3>Qr Kodu Tarayabilirsiniz</h3>
          <p>Sipariş ID: </p>
          <vs-row>
            <vs-col vs-w="3"></vs-col>
          <vs-col vs-type="center" vs-w="6" class="p-2">
        <div class="w-full text-center img-border p-5">
          <img src="@/assets/general/qr-code-scan.svg" class="w-full">
        </div>
      </vs-col> <vs-col vs-w="3"></vs-col>
          </vs-row>
          
          <vs-row vs-type="flex" vs-w="12">
            <input autocomplete="off" id="qrCode" name="Qr Kod" ref="qrInput" placeholder="Qr Kod"
              class="w-full text-dark weight-600 text-small border-all border-grey low-border-radius px-2" v-model="qrCode" />
            <span class="text-danger text-xsmaller"
              v-show="errors.has('Qr Kod')">{{ errors.first("Qr Kod") }}</span>
          </vs-row>
          <!-- <button class="btn btn-primary">Tamam</button> -->
          <button class="btn btn-secondary" @click="closeQrReader">İptal</button>
          <div v-if="qrCodeOrderData!=null">
            <table>
          <thead>
            <tr>
              <th>Sipariş ID</th>
              <th>Sipariş İçeriği</th>
              <th>Sipariş Saati</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ qrCodeOrderData.id }}</td>
              <td>
                <table>
                  <thead>
                    <tr>
                      <th>Ürün</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="product in qrCodeOrderData.cartEntries">
                         <th>{{ product.productName }}</th>
                         <th></th>
                    </tr>
                  </tbody>
                </table>

              </td>
              <td>{{qrCodeOrderData.deliveryDateString}}</td>
              <td>
                <button class="btn btn-success" @click="showPopup(qrCodeOrderData.id, 3)">Teslim Et</button>
              </td>
            </tr>
          </tbody>
        </table>
          </div>
          
        </div>
      </div>
    </div>
    </vs-popup>
  </template>
  
  <style>
  .kanban-board {
    display: flex;
    justify-content: space-between;
  }
  
  .kanban-column {
    flex: 1;
    margin: 0 10px;
    border-right: 1px solid #ccc; 
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  
  th, td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }
  
  th {
    background-color: #f2f2f2;
  }
  
  .btn {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    margin-right: 5px;
  }
  
  .btn-primary {
    background-color: #3399ff;
    color: #fff;
  }
  
  .btn-success {
    background-color: #00cc66;
    color: #fff;
  }
  
  .btn-warning {
    background-color: #ffcc00;
    color: #fff;
  }
  .btn-danger {
    background-color: #ff1500;
    color: #fff;
  }
  .popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .popup {
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
    width: 400px;
    text-align: center;
  }
  
  .popup button {
    margin-top: 10px;
  }

  .warning {
  animation: blinker 1s linear infinite;
  color: red;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
  </style>
  
  <script>
  import {
    mobileOrder,
    mobileOrderChangeStatus,
    qrCodeRead
  } from "@/api/SelfService.js";
  import  { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
  import Printer from "./Printer.vue"
  export default {
    props: {
      orderListIsActive: {
        type: Boolean,
        required: true
      }
    },
    components: {
    Printer
  },
    data() {
      return {
        orders:[],
        showPopupFlag: false,
        showPopupDetailFlag: false,
        selectedOrder: null,
        selectedStatus: '',
        changeStatusOrder:{
          orderId:null,
          orderStatus:null
        },
        showQrReader:false,
        qrCode: '',
        qrCodeOrderData:null,
        orderDetail:null,
        printeractive:false,
        currentDate :''
      }
    },
    mounted: function () {
      const connection =new HubConnectionBuilder().withUrl(process.env.VUE_APP_ROOT_API+'/hub',
{
    accessTokenFactory: () => {
      return localStorage.getItem("auth-token");
    }
  }).withAutomaticReconnect().build();
connection.start().then(() => {
});
connection.onreconnected((connectionId) => {
  console.log(`Bağlantı yenilendi. Yeni bağlantı ID'si: ${connectionId}`);
});

connection.serverTimeoutInMilliseconds = 30000; // 30 saniye

connection.keepAliveIntervalInMilliseconds = 5000; // 5 saniye
    connection.on("SendOrder", message => {
      this.orders.push(message);
      this.orders.sort(function(a, b) {
  return new Date(a.deliveryDate) - new Date(b.deliveryDate);
});
      // this.$vs.notify({
      //         color: "success",
      //         title: "Yeni sipariş geldi.",
      //         text: ""
      //       });
    });
    setInterval(() => {
      this.orders.forEach(order => {
        order.tableId = this.calculateRemainingSeconds(
          parseInt(order.deliveryDateString.split(":")[0]),
          parseInt(order.deliveryDateString.split(":")[1]),
          order.deliveryDate
        );
      });
    }, 1000);

    setInterval(() => {
      this.orders.forEach(order => {
        order.tableId -= 1;
      });
    }, 1000);
  },
  computed: {
    orderListIsActiveLocal: {
        get() {
          return this.orderListIsActive;
        },
        set(val) {
          if (!val) {
            this.$emit("close");
          }
        }
      }
  },
    methods: {
      calculateRemainingSeconds(hour, minute,deliveryDate) {
      const now = new Date();
      if (now>new Date(deliveryDate)) {
        return -999
      }
      const target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, minute, 0);
      const diff = target - now;
      const tableId = Math.floor(diff / 1000);
      return tableId;
    },
    remainingTime(tableId) {
      if (tableId <= 0) {
        return "Geçti";
      }
      const remainingHours = Math.floor(tableId / 3600);
      tableId %= 3600;
      const remainingMinutes = Math.floor(tableId / 60);
      tableId %= 60;
      return `${remainingMinutes}:${tableId}`;
    },
      groupExtras(extras) {
      const result = {}
      extras.forEach(extra => {
        if (extra.variants!=null&&extra.variants.length>0) {
          extra.variants.forEach(variant=>{
            if (!result[variant.name]) {
          result[variant.name] = {
            name: variant.name,
            quantity: 0
          }
        }
        result[variant.name].quantity += variant.quantity
          })
        }else{
          if (!result[extra.name]) {
          result[extra.name] = {
            name: extra.name,
            quantity: 0
          }
        }
        result[extra.name].quantity += extra.quantity
        }
        
      })
      return Object.values(result)
    },
      initValues() {
        this.qrCode = "";
      },
      showPopup(orderId, status) {
        this.selectedOrder = this.orders.find(order => order.id === orderId)
        this.selectedStatus = status
        this.showPopupFlag = true
      },
      showPopupDetail(order) {
        this.showPopupDetailFlag = true;
        this.orderDetail = order;
        this.printeractive=true
      },
      readQr(){
        this.showQrReader=true;
        this.$nextTick(() => {
        this.$refs.qrInput.focus();
      });
      },
      closePopup() {
        this.printeractive = false;
        this.showPopupFlag = false;
        this.showPopupDetailFlag = false;
      },
      printing(){
        this.getFullTime();
        this.$refs.printer.printOrders();
      },
      closeQrReader() {
        this.showQrReader = false;
        this.initValues();
      },
      moveOrder(orderId, status) {
        const orderIndex = this.orders.findIndex(order => order.id === orderId)
        
        this.changeStatusOrder.orderId=orderId;
        this.changeStatusOrder.orderStatus=status;
        mobileOrderChangeStatus(this.changeStatusOrder) .then(() => {
          this.orders[orderIndex].orderStatus = status
      if (status == -1 || status == 3) {
        this.$emit("emitRefresh");
      }
      if (status == 3) {
        this.$vs.notify({
          color: "success",
          title: "Başarılı",
          text: 'Sipariş teslim edildi',
        });
      }
      if (status == -1) {
        this.$vs.notify({
          color: "success",
          title: "Başarılı",
          text: 'Sipariş iptal edildi',
        });
      }
    })
    .catch(error => {
      this.$vs.notify({
          color: "danger",
          title: "Başarısız",
          text: error.response.data.Errors[0].Message,
        });
    });
        this.qrCodeOrderData = null;
        this.qrCode = '';
        this.showQrReader = false;
        this.initValues();
        this.closePopup()
      },
      getOrder:async function(){
        this.orders=await mobileOrder();
        this.orders.sort(function(a, b) {
  return new Date(a.deliveryDate) - new Date(b.deliveryDate);
});
      },
      getFullTime(){
        const date = new Date();
        const options = {
        timeZone: 'Europe/Istanbul',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    };
    this.currentDate = date.toLocaleString('tr-TR', options);
      },
      qrCodeReadFunc: async function(val){
        try {
        var qrresult = await qrCodeRead(val);
          if (qrresult.result==false) {
            this.$fire({
              title: "Bulunamadı ! ",
              text: qrresult.errors[0].message,
              type: "error"
            });
          }else{
            this.qrCodeOrderData= qrresult.data;
          }
        } catch(e){
          this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error"
        })
        }
      }
    },
    created: async function () {
    this.orders=await mobileOrder();
    this.orders.sort(function(a, b) {
  return new Date(a.deliveryDate) - new Date(b.deliveryDate);
});
  },
  watch: {
      qrCode(val) {
        this.qrCodeOrderData=null;
        if (val && val.length == 10){
         this.qrCodeReadFunc(val);
        };
      }
    }
  }
  </script>